let clickOutsideEvent: ((event: Event) => void) | null = null

const mounted = function (el: HTMLElement, binding: { value: (event: Event) => void }) {
  clickOutsideEvent = function (event: Event) {
    // Check if event target exists and is a valid Node
    if (!event.target || !(event.target instanceof Node)) return

    // Check if click is outside the element and its children
    if (!(el === event.target || el.contains(event.target))) {
      // Call method provided in attribute value
      if (typeof binding.value === 'function') {
        binding.value(event)
      }
    }
  }
  document.addEventListener('mousedown', clickOutsideEvent)
}

const unmounted = function () {
  if (clickOutsideEvent) {
    document.removeEventListener('mousedown', clickOutsideEvent)
    clickOutsideEvent = null
  }
}

export default {
  mounted,
  unmounted,
}
